import ErrorHandler from "@/utils/errorHandler"
const str = 'qwertyuiopasdfghjklzxcvbnm!@#)$%^&*+=-?.*~(_\'\"123456789'

export default {
    install(Vue) {
        Vue.prototype.$randomInteger = (min, max) => {
            return Math.round(min + Math.random() * (max - min));
        }

        Vue.prototype.$generate = (obj = {min: 12, max: 16}) => {
            try {
                let password = ''
                const int = Vue.prototype.$randomInteger(obj.min, obj.max)

                while(password.length !== int) {
                    const symbol = str[Vue.prototype.$randomInteger(0, str.length-1)]
                    const symbolCase = [symbol.toUpperCase(), symbol.toLocaleString()]
                    password += symbolCase[Vue.prototype.$randomInteger(0, 1)]
                }

                return password
            } catch (e) {
                new ErrorHandler(e).send
            }
        }

        return Vue
    }
}
